import React, { lazy, Suspense } from 'react';
import { Typography } from '@mui/material';

import NewsBanner, { shouldDisplayNewsBannerInBooking } from 'components/common/NewsBanner';
import Link from 'mui/components/elements/Link';
import { useLocationStep } from 'components/Booking-new/utils/steps/location';
import { pushGTMChooseLocationEvent } from 'utils/gtm';
import translationsLocations from 'mui/components/sections/DS_LocationHero/elements/data/translationsLocations';

import StepHeader from '../../../../shared/StepHeader';
import { StepLocationCommonPropTypes } from '../../types';

import { StyledDescription, LinkWrapper, StyledBannerWrapper, StyledWrapper } from './styles';

const DS_MapLocations = lazy(() => import('mui/components/sections/DS_FindInMap/components/DS_MapLocations'));

const ChooseLocationDesktop = ({
  stepLocation,
  allLocations,
  selectedLocationState,
  locationsWrapperRef,
  changeServiceLink,
  showNewsBanner,
  funnelType,
  navigation,
  rescheduleData,
  serviceCode,
}) => {
  const newsBannerVisible = shouldDisplayNewsBannerInBooking(stepLocation.newsBanner, showNewsBanner);
  const { selectLocation } = useLocationStep();

  const onLocationSelection = location => {
    pushGTMChooseLocationEvent(location.code, funnelType);
    selectLocation(location);
  };

  const { nextAppointment: nextAppointmentLabel } = translationsLocations[process.env.GATSBY_COUNTRY_CODE];

  const mapLocationsData = {
    allLocations,
    nextAppointmentLabel,
    searchPlaceholder: stepLocation?.searchPlaceholder,
    flagshipLocationLabel: stepLocation?.useFlagshipStoreLabel,
    useFlagshipStoreLabel: stepLocation?.useFlagshipStoreLabel,
    bookingButton: {
      title: stepLocation?.bookingButtonLabel,
    },
    onLocationSelection,
    isBookingFunnel: true,
    bookingFunnelSelectedLocation: selectedLocationState[0],
    showDailyFilters: stepLocation?.showDailyFilters,
    sortingAlgorithm: stepLocation.sortingAlgorithm,
    showTimeSlots: stepLocation?.showTimeSlots,
    noDatesAvailableLT: stepLocation?.noDatesAvailableLT,
    waitlistButtonLabelLT: stepLocation?.waitlistButtonLabelLT,
    confirmationDialogLabelLT: stepLocation?.confirmationDialogLabelLT,
    cancelDialogLabelLT: stepLocation?.cancelDialogLabelLT,
    waitlistSuccessLinkLT: stepLocation?.waitlistSuccessLinkLT,
    useDiscountOnFlagship: stepLocation?.useDiscountOnFlagship,
    discountFlagshipText: stepLocation?.discountFlagshipText,
    discountDisclaimer: stepLocation?.asteriskFootnote?.asteriskFootnote,
    navigation,
    rescheduleData,
    serviceCode,
    funnelType,
  };

  return (
    <StyledWrapper>
      <div ref={locationsWrapperRef}>
        <div>
          {stepLocation?.title && <StepHeader data-test="booking-location-title" title={stepLocation.title} />}
          {stepLocation?.description?.markdown?.html && (
            <Suspense fallback={<div />}>
              <StyledDescription>{stepLocation.description.markdown.html}</StyledDescription>
            </Suspense>
          )}
          {changeServiceLink?.url && (
            <LinkWrapper>
              <Typography component={Link} variant="DS_labelSmallRegular" url={changeServiceLink.url}>
                <span>{changeServiceLink.title}</span>
              </Typography>
            </LinkWrapper>
          )}
        </div>

        {newsBannerVisible && (
          <StyledBannerWrapper>
            <NewsBanner newsBanner={stepLocation?.newsBanner} alert={true} />
          </StyledBannerWrapper>
        )}

        <Suspense fallback={<div />}>
          <DS_MapLocations {...mapLocationsData}></DS_MapLocations>
        </Suspense>
      </div>
    </StyledWrapper>
  );
};

export default ChooseLocationDesktop;

ChooseLocationDesktop.propTypes = {
  ...StepLocationCommonPropTypes,
};
